"use client";

import {
  NOTION_READ_TOOLS,
  NOTION_WRITE_TOOLS,
} from "@workspace/connectors/definitions";
import { lazy } from "react";
import { createMcpToolRegistry } from "../mcp-tool-registry";

const notionMcpToolView = lazy(() =>
  import("./tool-view").then(({ NotionMcpToolView }) => ({
    default: NotionMcpToolView,
  }))
);

/**
 * Notion is an MCP + progressive-disclosure capability — its tool parts arrive
 * as `notion_${mcpToolName}`. See `createMcpToolRegistry`.
 */
export const notionToolRegistry = createMcpToolRegistry({
  prefix: "notion",
  readTools: NOTION_READ_TOOLS,
  writeTools: NOTION_WRITE_TOOLS,
  view: notionMcpToolView,
});
